module.exports = {"411282100":"城关镇","411282101":"尹庄镇","411282102":"朱阳镇","411282103":"阳平镇","411282104":"故县镇","411282105":"豫灵镇","411282106":"大王镇","411282107":"阳店镇","411282108":"函谷关镇","411282109":"焦村镇","411282200":"川口乡","411282201":"寺河乡","411282202":"苏村乡","411282203":"五亩乡","411282204":"西阎乡","411282400":"灵宝市园艺场","411282401":"涧东区","411282402":"涧西区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411282.json
// module id = 1759
// module chunks = 0